import { useEffect, useState } from "react";
import Header from "../../Components/SDE24/Header";
import { useTranslation } from "react-i18next";
import * as api from '../../../api';
import Section from "../../Atoms/Section";
import { useNavigate } from "react-router";
import Spinner from "../../../Plateforme/Atoms/Spinner";
import styled from "styled-components";
import dayjs from 'dayjs';
import CompanyMoreInformation from "../../Components/SDE24/CompanyMoreInformation";

const CompanyContainer = styled.div`
    margin: 10px 0;
    padding : 10px;
    background-color: white;
    position: relative;

    & > img {
        max-width: 120px;
        max-height: 120px;
        position:absolute;
        top:10px;
        right:10px;
    }

    & > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    & > div > button {
        max-width: 200px;
    }

    & .newtag {
        position: absolute;
        top: 0;
        right: 0;
        color: white;
        background-color: #46d84c;
        border-radius: 0 0 0 10px;
        font-weight: 200;
        font-size: 10px;
        padding: 5px;
    }
`

const Prescripteurs = (props) => {

    const [event, setEvent] = useState(null);
    const [participation, setParticipation] = useState(null);
    const [planning, setPlanning] = useState(null);
    const [userRDVs, setUserRDVs] = useState(null);
    const navigate = useNavigate();

    const { i18n } = useTranslation('common');

    //get eid and uid from url, then get users participations, then get the right one and set it in state
    useEffect(() => {
        const eventIdFromParam = new URLSearchParams(window.location.search).get("eid");
        const userIdFromParam = new URLSearchParams(window.location.search).get("uid");
        
        if (!eventIdFromParam || !userIdFromParam) {
            console.log("no event id or user id in url");
            return;
        }

        api.getEventById({ id: eventIdFromParam }).then((response) => {
            setEvent(response.data);
        }).catch((error) => {
            console.log(error);
        });

        api.getUserParticipations({userid: userIdFromParam}).then((resParticipations) => {
            const matchingParticipation = resParticipations.data.find(participation => participation.eventId === eventIdFromParam);
            if(matchingParticipation) {
                setParticipation(matchingParticipation);
            }
        })

        api.GetPlanning({eventId:eventIdFromParam}).then((response) => {
            console.log("response.data of GetPlanning")
            console.log(response.data)
            setPlanning(response.data);
        })
    }, [])

    const [participatingCompanies, setParticipatingCompanies] = useState([]);

    const [selectedCompany, setSelectedCompany] = useState(null);

    // get participating companies
    useEffect(() => {
        if(!event) return;
        api.getParticipatingUsersWithData({eventId : event._id}).then((response) => {
            console.log("response.data of getParticipatingUsersWithData")
            console.log(response.data)
            setParticipatingCompanies(response.data.filter((participation) => participation.participation.type[3] === "a"));
        }).catch((error) => {
            console.log(error);
        });
    },[event]);

    // comput user rdvs
    useEffect(() => {
        if(!event || !planning || !participation || !participatingCompanies?.length) return;
        const userRDVs = planning.data
            .filter((rdv) => rdv.designerParticipationId === participation._id)
            .map((rdv) => {
                return {
                    ...rdv,
                    company: participatingCompanies.find((company) => company.participation._id === rdv.participationId),
                    slot: planning.slots.find((slot) => slot.id === rdv.slotId)
                }
            })
            .sort((a,b) => a.slot.horaire.localeCompare(b.slot.horaire));

        console.log("userRDVs")
        console.log(userRDVs)
        setUserRDVs(userRDVs);

    },[event,planning,participation,participatingCompanies]);

    useEffect(() => {
        document.getElementsByTagName('html')[0].scrollTo(0,0);
        console.log("shouldScroll")
    }, [selectedCompany]);

    function CompanyLine(props){
        return (
            <CompanyContainer>
                <h2 onClick={props.onClick}>{props.participation.hsCompany?.properties.name.toUpperCase()}</h2>
                {/* <span className='thin'>{props.participation.participation.data.numTableOULienZoom}</span><br/> */}
                {props.participation.company.logo && <img alt="" src={process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + props.participation.company.logo}/>}<br/>
                <p style={{textTransform:"capitalize"}}>{props.participation.participation.data.presentiel === "oui" && (dayjs(event.main_date).format('dddd D MMMM YYYY') + " | " + props.rdv.slot.horaire + " | Table n°" + props.participation.participation?.data?.numTableOULienZoom + " | "+ event.localisation)}{props.participation.participation.data.presentiel === "non" && (dayjs(event.online_date).format('dddd D MMMM YYYY') +  " | " + props.rdv.slot.horaire + " | Lien zoom : " + props.participation.participation?.data?.numTableOULienZoom)}</p>
                <p className='thin preformatted'>{i18n.language === "fr" ? props.participation.participation.data.description_admin_fr : props.participation.participation.data.description_admin_en}</p>
                <div>
                    <button className='centered' onClick={props.onClick}>{i18n.language === "fr" ? "Plus d'informations" : "More information"}</button>
                </div>
            </CompanyContainer>
        )
    }

    if (!event) {
        return <><br/><Spinner/></>
    }

    return (
        <div>
            <Header overrideTitle={event._id === "663a220d253dde5f2058429b" ? "SPEED DATING DESIGN OBJET : mardi 04 juin" : ''} overrideSentence={" "}/>
            {props.fullUser?.user ? 
                <div>
                {!selectedCompany && <>
                    <Section className='padding'>
                        <span className='linkbutton' onClick={() => navigate('/evenements/')}>← {i18n.language === "fr" ? "Retour" : "Back"}</span>
                    </Section>
                </>}
                {props.fullUser?.user && event ? <>
                    {!selectedCompany && <>
                        <Section className='padding'>
                            <h1 className='centered'>{i18n.language === "fr" ? "Vos prescripteurs" : "Your specifiers"}</h1>
                            <br/>
                            <p className="centered">
                                {i18n.language === "fr" ? "Voici la liste des sociétés que vous allez rencontrer lors de l'événement :" : "Here is the list of companies you will meet during the event:"}
                            </p>
                            <br/>
                            {userRDVs ? <>
                                {userRDVs.length === 0 ? <p className='centered'>{i18n.language === "fr" ? "Vous n'avez pas de rendez-vous" : "You don't have any meeting"}</p> : <div className='line_cont'>
                                    {userRDVs.map((rdv,i) =>
                                        <CompanyLine key={i} participation={rdv.company} onClick={()=>setSelectedCompany(rdv.company)} rdv={rdv}/>
                                    )}
                                </div>}
                            </> : <><Spinner/></>}
                        </Section>
                    </>}
                    {selectedCompany && <CompanyMoreInformation company={selectedCompany} onBack={()=>setSelectedCompany(null)} showCandidateButton={false} candidaturesMaxed={false} onCandidate={()=>{}} event={event} />}
                </> : <><br/><Spinner/></>}
            </div>
            :
                <><br/><Spinner/></>
            }
            {event.type === "sdo" ? <Section className="padding">{i18n.language === "fr" ? "Si vous rencontrez un problème lors de votre inscription, merci d'envoyer un email détaillant votre problème à l'adresse suivante : design@via.fr." : "If you encounter any issue during your registration, please send an email detailing your problem to the following address: design@via.fr."}</Section> : <Section className="padding">{i18n.language === "fr" ? "Si vous rencontrez un problème lors de votre inscription, merci d'envoyer un email détaillant votre problème à l'adresse suivante : boury@via.fr, nous reviendrons vers vous rapidement. Pour les urgences, contactez le +33144681814 (du lundi au vendredi - 10h/17h)." : "If you encounter any issue during your registration, please send an email detailing your problem to the following address: boury@via.fr, we will get back to you quickly. For emergencies, contact +33144681814 (Monday to Friday - 10am/5pm)."}</Section>}
        </div>
    )
}

export default Prescripteurs;